enum AnalyticsProviders {
    META = "meta",
    GA = "ga",
    SNAP = "snap",
    BING = "bing",
  }
  
  export default AnalyticsProviders;